import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";

/**
 * Returns the user's declared state/province from their userProfiles doc.
 * Used to filter regional content (experts, opportunities, etc.).
 */
export function useUserRegion(userId?: string | null): string | undefined {
  const [region, setRegion] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!userId) {
      setRegion(undefined);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "userProfiles", userId));
        if (cancelled) return;
        const data = snap.data() as any;
        if (!data) return;
        setRegion(data.stateProvince || data.state || data.province || undefined);
      } catch (err) {
        console.error("useUserRegion error:", err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return region;
}
